import Tutorial from '../api/tutorial';
import { applicationSave, applicationFetch } from './applicationActions';

export const saveTutorial = applicationSave(Tutorial);
export const fetchTutorial = applicationFetch(Tutorial);
